/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    fillColor?: keyof typeof theme.colors | 'none';
    strokeColor?: keyof typeof theme.colors;
    iColor?: keyof typeof theme.colors;
};

export default function CircleInfoIcon({
    fillColor,
    strokeColor,
    iColor,
    ...props
}: Props) {
    const theme = useTheme();

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            role="img"
        >
            <circle
                cx="10"
                cy="10"
                r="9.5"
                fill={
                    fillColor && fillColor !== 'none'
                        ? theme.colors[fillColor]
                        : fillColor !== 'none'
                        ? '#F69338'
                        : 'none'
                }
                {...(strokeColor
                    ? { stroke: theme.colors[strokeColor], strokeWidth: 1 }
                    : {})}
            />
            <path
                fill={iColor ? theme.colors[iColor] : '#282B43'}
                d="M10.216 6.432A1.226 1.226 0 0 1 9 5.216C9 4.544 9.56 4 10.216 4a1.215 1.215 0 1 1 0 2.432Zm-1.008 8.864V7.568h2.032v7.728H9.208Z"
            />
        </svg>
    );
}
